import { API_URL } from '../../../components/config/BaseUrl';

export const GET_CONFERENCES_URL = `${API_URL}/wificall/conference`;
export const ADD_CONFERENCE_URL = `${API_URL}/wificall/conference`;
